import { useEffect, useRef } from "react";
import { Flex, Paper, Header3, MainText, PrimaryButton } from "@base-ui";
import { closePopup, blockDefaultEvent } from "utils/events";
import { useLockedFocusArea } from "hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RemovePopup(props) {
  var title = props.title,
    callback = props.callback,
    toBeRemoved = props.toBeRemoved;
  var containerRef = useRef();
  var firstRef = useRef();
  var lastRef = useRef();
  useLockedFocusArea(containerRef, firstRef, lastRef);
  useEffect(function () {
    document.getElementById("confirm").focus();
  }, []);
  var handleRemove = function handleRemove() {
    callback();
    closePopup();
  };
  var handleCancel = function handleCancel(e) {
    blockDefaultEvent(e);
    closePopup();
  };
  return /*#__PURE__*/_jsxs(Paper.Column, {
    width: "500px",
    ref: containerRef,
    children: [/*#__PURE__*/_jsx(Header3, {
      id: "dialog-title",
      inverted: true,
      p: "15px 20px",
      backgroundColor: "P3",
      m: "0",
      children: title
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      p: "sm",
      children: [/*#__PURE__*/_jsxs(MainText, {
        mb: "40px",
        children: ["\xC4r du s\xE4ker p\xE5 att du vill ta bort", /*#__PURE__*/_jsx("i", {
          children: " \"".concat(toBeRemoved, "\"?")
        })]
      }), /*#__PURE__*/_jsxs(Flex.Row, {
        justifyContent: "flex-end",
        children: [/*#__PURE__*/_jsx(PrimaryButton, {
          ref: firstRef,
          id: "leave-popup",
          mr: "10px",
          width: "120px",
          onClick: handleCancel,
          children: "Avbryt"
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          id: "confirm",
          ref: lastRef,
          width: "120px",
          onClick: handleRemove,
          children: "Ta bort"
        })]
      })]
    })]
  });
}